import React from 'react';
import { StepList } from '@bingads-webui-react/wizard-ui-library';
import { HorizontalStepList } from '@bingads-webui-react/step-progress-indicator';

import { useStepListConfig } from './step-list-config';

export const PreviewFlowStepList = (props) => {
  const stepListProps = useStepListConfig();

  return (
    <StepList
      {...props}
      {...stepListProps}
      LargeScreenStepListComponent={HorizontalStepList}
    />
  );
};
